export default {
  path: '/2019HealthContributionBrand',
  name: 'HealthContributionBrand2019',
  component: () => import('./home.vue'),
  base: '/2019HealthContributionBrand/',
  meta: {
    title: '健康70年---重庆健康民生贡献力70品牌寻找与展示活动',
  },
  children: [
    {
      path: 'FirstPage',
      component: () => import('./FirstPage.vue'),
      name: '2019HealthContributionBrandFirstPage',
      meta: {
        title: '健康70年---重庆健康民生贡献力70品牌寻找与展示活动',
      },
    },
    {
      path: 'List',
      component: () => import('./List.vue'),
      name: '2019HealthContributionBrandList',
      meta: {
        title: '健康70年---重庆健康民生贡献力70品牌寻找与展示活动',
      },
    },
    {
      path: 'Register',
      component: () => import('./Register.vue'),
      name: '2019HealthContributionBrandRegister',
      meta: {
        title: '健康70年---重庆健康民生贡献力70品牌寻找与展示活动',
      },
    },
    {
      path: 'DetailPage',
      component: () => import('./DetailPage.vue'),
      name: '2019HealthContributionBrandDetailPage',
      meta: {
        title: '健康70年---重庆健康民生贡献力70品牌寻找与展示活动',
      },
    },
    {
      path: 'Rules',
      component: () => import('./Rules.vue'),
      name: '2019HealthContributionBrandRules',
      meta: {
        title: '健康70年---重庆健康民生贡献力70品牌寻找与展示活动',
      },
    },
    {
      path: 'NewsPage',
      component: () => import('./NewsPage.vue'),
      name: '2019HealthContributionBrandNewsPage',
      meta: {
        title: '健康70年---重庆健康民生贡献力70品牌寻找与展示活动',
      },
    },
    {
      path: 'Recommend',
      component: () => import('./Recommend.vue'),
      name: '2019HealthContributionBrandRecommend',
      meta: {
        title: '健康70年---重庆健康民生贡献力70品牌寻找与展示活动',
      },
    },
  ],
};
